import { jsx as _jsx } from "react/jsx-runtime";
import { useDragableElement } from "@core-utils/react-hooks";
export const BubbleWrapper = ({ className, id, children, onClick, style }) => {
    const { onSelect } = useDragableElement(`bubble-${id}`);
    return _jsx("div", { onClick: onClick || onSelect, style: style || {}, id: `bubble-${id}`, className: `text-lg ${className}`, children: _jsx("div", { className: "bubble-container", children: _jsx("div", { className: "bubble flex justify-center items-center", children: children && children }) }) });
};
